import LottieView from './LottieView';

export default LottieView;
